import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Dropzone } from '@/components/ui/dropzone'
import { useImportCustomer } from '@/models/qa'
import { ImportCustomerResult } from './ImportCustomerResult'

function errorMessage(error: unknown): string {
  const detail = (error as { response?: { data?: { file?: string[] | string } } }).response?.data?.file
  if (Array.isArray(detail)) return detail.join(' ')
  return detail ?? (error as Error).message
}

/** Loads a customer fixture downloaded from another environment's customer page. */
export function ImportCustomerCard() {
  const [file, setFile] = useState<File | null>(null)
  const { mutate: importCustomer, isPending, data: result, error } = useImportCustomer()

  return (
    <Card>
      <CardHeader>
        <CardTitle>Import customer</CardTitle>
        <CardDescription>
          Load a customer exported with the Export button on a customer page — the org, motor carrier, fleet,
          drivers, applications, loss runs, claims, quotes, policies, COIs, notes, chats and documents.
          Importing the same customer again fills in whatever is missing instead of duplicating it. Document
          downloads expire an hour after the export, so import promptly.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <Dropzone accept=".json" maxSizeMB={50} onChange={setFile} isLoading={isPending} />
        <Button
          disabled={!file}
          loading={isPending ? 'Importing…' : undefined}
          onClick={() => file && importCustomer(file)}
        >
          Import customer
        </Button>
        {result && <ImportCustomerResult result={result} />}
        {error && <p className="text-sm text-red-600">Error: {errorMessage(error)}</p>}
      </CardContent>
    </Card>
  )
}
